module.exports = {"530128001":"屏山街道","530128002":"崇德街道","530128102":"撒营盘镇","530128103":"转龙镇","530128104":"茂山镇","530128105":"团街镇","530128106":"中屏镇","530128107":"皎平渡镇","530128108":"乌东德镇","530128109":"翠华镇","530128110":"九龙镇","530128204":"云龙乡","530128207":"汤郎乡","530128208":"马鹿塘乡","530128211":"则黑乡","530128212":"乌蒙乡","530128213":"雪山乡","530128401":"禄劝工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530128.json
// module id = 2684
// module chunks = 0